/**
 * Con un `tooltip` il bottone sta dentro uno span (il trigger del tooltip),
 * che diventa lui l'elemento del layout del genitore. Le classi che parlano
 * a quel layout vanno quindi sullo span:
 * - larghezza, crescita nel flex e visibilità (`w-full`, `flex-1`,
 *   `hidden`, …) restano ANCHE sul bottone, che deve riempire lo span e
 *   sparire con lui;
 * - posizione nel genitore (margini, `self-*`, `order-*`, span di griglia)
 *   passa SOLO allo span, altrimenti si applicherebbe due volte.
 * Un `display` con variante (`sm:inline-flex`) segue lo span solo accanto a
 * un `hidden`: da solo descrive l'interno del bottone, e sullo span lo
 * renderebbe un blocco.
 */
const SHARED_CLASS_PATTERN = /^(w|min-w|max-w)-|^(flex-(1|auto|initial|none)|grow(-\d+)?|shrink(-\d+)?|basis-.+)$/;
const HIDDEN_CLASS_PATTERN = /^(hidden|invisible)$/;
const DISPLAY_CLASS_PATTERN = /^(block|inline|inline-block|flex|inline-flex|grid|inline-grid)$/;
const WRAPPER_ONLY_CLASS_PATTERN = /^-?m[trblxyse]?-|^(self|order|justify-self|place-self|col-span|col-start|col-end|row-span|row-start|row-end)-/;
/** Ultimo segmento di una classe Tailwind, senza varianti né `!`. */
function utilityOf(token) {
    let depth = 0;
    let start = 0;
    for (let index = 0; index < token.length; index += 1) {
        const char = token[index];
        if (char === '[')
            depth += 1;
        else if (char === ']')
            depth -= 1;
        else if (char === ':' && depth === 0)
            start = index + 1;
    }
    return token.slice(start).replace(/^!|!$/g, '');
}
const hasVariant = (token) => utilityOf(token) !== token.replace(/^!|!$/g, '');
export function splitTooltipWrapperClasses(className) {
    const tokens = (className ?? '').split(/\s+/).filter(Boolean);
    const hidesItself = tokens.some((token) => HIDDEN_CLASS_PATTERN.test(utilityOf(token)));
    const wrapper = [];
    const button = [];
    tokens.forEach((token) => {
        const utility = utilityOf(token);
        if (WRAPPER_ONLY_CLASS_PATTERN.test(utility)) {
            wrapper.push(token);
            return;
        }
        button.push(token);
        const isVisibilityToggle = hidesItself && hasVariant(token) && DISPLAY_CLASS_PATTERN.test(utility);
        if (SHARED_CLASS_PATTERN.test(utility) ||
            HIDDEN_CLASS_PATTERN.test(utility) ||
            isVisibilityToggle) {
            wrapper.push(token);
        }
    });
    return { wrapper: wrapper.join(' '), button: button.join(' ') };
}
//# sourceMappingURL=tooltip-wrapper-classes.js.map